import { OptionField } from '$/GraphQL/schema/types';

export const surfaceAnswerText = (
  options?: OptionField[] | null,
  answers?: string[] | null
): string => {
  if (!options || !answers) return '';
  const optionsField = options.filter((a) => a.value && answers.includes(a.value));
  if (optionsField && optionsField.length > 0) {
    return optionsField.map((o) => o.text).join(', ');
  }
  return answers.join(', ') || '';
};
